if (!customElements.get('collection-infinite-scroll')) {
  class CollectionInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.nextUrl = this.dataset.nextUrl;
      this.button = this.querySelector('.collection-infinite-scroll__button');
      if (!this.nextUrl || !this.button) return;

      // Page numbers stay in the markup as a fallback when JavaScript is off.
      const pagination = this.querySelector('.pagination-wrapper');
      if (pagination) pagination.hidden = true;
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.loadMore());

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) this.loadMore();
        },
        { rootMargin: '0px 0px 800px 0px' }
      );
      this.observer.observe(this.button);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    async loadMore() {
      if (this.loading || !this.nextUrl) return;
      this.loading = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');

      try {
        const url = new URL(this.nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to load products (${response.status})`);

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = document.getElementById('product-grid');
        grid.append(...html.querySelectorAll('#product-grid > .grid__item'));

        const next = html.querySelector('collection-infinite-scroll');
        this.nextUrl = next ? next.dataset.nextUrl : '';
      } catch (error) {
        // Stop auto-loading; the button stays so customers can retry.
        console.error(error);
        if (this.observer) this.observer.disconnect();
      } finally {
        this.loading = false;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
        if (!this.nextUrl) this.remove();
      }
    }
  }

  customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
}
